// extracted by mini-css-extract-plugin
export const pageNav = "CommentTemplate-module--pageNav--1-Rpl";
export const pageNavMenu = "CommentTemplate-module--pageNavMenu--1gnyD";